var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarbijoDeTela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39204 4.10001C0.886073 2.58211 0.472028 1 2.82203 1C5.89203 1.10001 2.39203 3.10001 10.392 4.1L9.89202 5.8C9.39203 7.09999 9.39202 7.1 7.89203 7.59999L7.89202 7.6C6.39203 7.6 5.39203 7.6 3.89203 7.1C2.39203 6.6 1.89205 5.60002 1.39204 4.10001Z",
    fill: "#FFCA15",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbijoDeTela);
export default __webpack_public_path__ + "static/media/BarbijoDeTela.47da2baa3d08844ab9eb101027581932.svg";
export { ForwardRef as ReactComponent };